import React from "react";
import { Modal, Button, Form } from "@deere/ux.uxframe-react";
import { CM_ADMIN_QUE_LBL } from '../../utils/surveyLiterals';

export const CMDeereUserSubmitConfirmation = ({ showModal, setShowModal, labelBtnPrimary, labelBtnSecondary, handleSubmit, titleModal, adminResponsePopup, setAdminResponsePopup }) => {
  const closeModal = () => {
    setAdminResponsePopup("");
    setShowModal(false);
  };

  const changeHandler = (e) => {
    setAdminResponsePopup(e.target.value);
  }

  const submitHandler = () => {
    setShowModal(false);
    handleSubmit();
  }

  return (
    <Modal show={showModal} backdrop="static">
      <Modal.Header>
        <Modal.Title>{titleModal}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="overflow-hidden">
        <Form.Group>
          <Form.Label className="uxf-label">{CM_ADMIN_QUE_LBL}</Form.Label>
          <Form.Control as="textarea" aria-label="With textarea" value={adminResponsePopup} onChange={changeHandler}/>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          {labelBtnSecondary}
        </Button>
        <Button type="submit" variant="primary" onClick={submitHandler}>
          {labelBtnPrimary}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
